// Copyright (c) 2018 Comsearch, Inc., All rights reserved

const getInitialValues = unitType => ({
  advancedSearch: '',
  'adv-antennaApplicationId': '',
  'adv-beamwidth': '',
  'adv-classificationId': '',
  'adv-complianceId': '',
  'adv-diameter': '',
  'adv-diameterUnit': unitType,
  'adv-gain': '',
  'adv-modifiedAntennaCode': '',
  'adv-rpeNumber': '',
  'adv-statusId': '',
  antennaCode: '',
  antennaFamily: '',
  companyName: '',
  feedDir: '',
  frequency: '',
  modelNumber: '',
  pagination: null,
})

export default getInitialValues
